import { IObjectDevicesComponents } from '@ucheba/utils/helpers/components/types'
import dynamic from 'next/dynamic'
import { NextPage, NextPageContext } from 'next'
import { getIDeviceComponent } from '@ucheba/utils/helpers/components'
import React from 'react'
import { NextSeo } from 'next-seo'
import { Store } from 'redux'
import { sendRequest } from '@ucheba/utils/helpers/api'
import { useDispatch } from 'react-redux'
import { pageDataHeaderOffersThunks } from '@ucheba/store/page-data/for-abiturients/headerOffers'
import { IAdmissionSupportPageProps } from './types'
import { headerActions } from '../../../components/Header/store'
import { footerActions } from '../../../components/Footer/store'
import { footerNavSchoolLinks } from '../school/index/constants'
import { useShowPhoneAndMessengers } from '../../../../utils/hooks/useShowPhoneAndMessengers'

const devicesPages: IObjectDevicesComponents = {
  desktop: dynamic(() => import('./desktop')),
  touch: dynamic(() => import('./touch')),
}

const EscortPage: NextPage<IAdmissionSupportPageProps> = (props) => {
  const { content } = props
  const dispatch = useDispatch()
  const isShowPhoneAndMessengers = useShowPhoneAndMessengers()

  if (!isShowPhoneAndMessengers) {
    const item = footerNavSchoolLinks[0]
    dispatch(headerActions.showPhone(false))
    dispatch(footerActions.setShowMessengers(false))
    dispatch(footerActions.setNavLinks([item]))
  } else {
    dispatch(headerActions.showPhone(true))
    dispatch(footerActions.setShowMessengers(true))
    dispatch(footerActions.setNavLinks(footerNavSchoolLinks))
  }

  return (
    <>
      <NextSeo
        title={content?.seo?.title}
        description={content?.seo?.description}
        openGraph={{
          images: [
            {
              url: content?.seo?.image || '',
              width: 1200,
              height: 630,
            },
          ],
        }}
      />

      {getIDeviceComponent({ ...props, content }, devicesPages)}
    </>
  )
}

EscortPage.getInitialProps = async (
  ctx: NextPageContext & { store: Store }
): Promise<any> => {
  const { store, query } = ctx
  const { dispatch } = store

  dispatch(footerActions.setColor('black'))
  dispatch(headerActions.toggleHeader(false))
  dispatch(footerActions.setNavLinks(footerNavSchoolLinks))

  const response = await sendRequest({ url: '/page_data/admission_support', ctx })
  if (query.offer) {
    await dispatch(pageDataHeaderOffersThunks.fetch({ ctx }))
  }

  const content = response?.data

  return {
    content,
  }
}

export default EscortPage
